import React, { useEffect, useState } from 'react';
import { studentApi } from '../../services/api';

interface BoardSession {
  id: number | string;
  title?: string | null;
  subject?: string | null;
  topic?: string | null;
  teacher_name?: string | null;
  started_at?: string | null;
  ended_at?: string | null;
  status?: string;
  join_url?: string | null;
}

const PALETTE = ['#3973bf', '#6d79ff', '#00c6af', '#e5599b', '#f87aff', '#f1972f'];

const StudentSmartBoard: React.FC = () => {
  const [boards, setBoards] = useState<BoardSession[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    studentApi.smartboard()
      .then((res) => setBoards(res.data || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <h1 className="text-[20px] lg:text-[24px] font-semibold text-[#2b2b2b] mb-4 lg:mb-6">Akıllı Tahta</h1>

      {loading ? (
        <div className="flex justify-center py-16"><div className="w-8 h-8 border-4 border-[#3973bf] border-t-transparent rounded-full animate-spin" /></div>
      ) : boards.length === 0 ? (
        <p className="text-center text-gray-400 py-16">Aktif bir akıllı tahta oturumu yok.</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-5">
          {boards.map((b, i) => {
            const color = PALETTE[i % PALETTE.length];
            const subjectTopic = [b.subject, b.topic].filter(Boolean).join(' - ') || b.title || 'Oturum';
            const d = b.started_at ? new Date(b.started_at).toLocaleDateString('tr-TR') : '—';
            return (
              <div key={b.id} className="bg-[#fafafa] rounded-[24px] overflow-hidden" style={{ boxShadow: '0px 1px 4px rgba(0,0,0,0.12)' }}>
                <div className="h-[100px] lg:h-[130px] flex items-center justify-center" style={{ backgroundColor: color }}>
                  <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                    <rect x="4" y="4" width="40" height="30" rx="4" stroke="white" strokeWidth="2.5" fill="none"/>
                    <path d="M18 34v6M30 34v6M14 40h20" stroke="white" strokeWidth="2.5"/>
                    <path d="M14 14h20M14 20h14" stroke="white" strokeWidth="2" strokeOpacity="0.6"/>
                  </svg>
                </div>
                <div className="p-4 lg:p-5">
                  <p className="text-[14px] lg:text-[16px] font-bold text-[#2b2b2b]">{subjectTopic}</p>
                  {b.teacher_name && <p className="text-[12px] lg:text-[14px] text-gray-500 mt-1">{b.teacher_name}</p>}
                  <div className="flex items-center justify-between mt-3">
                    <span className="text-[12px] lg:text-[14px] text-gray-500">{d}</span>
                    <button
                      onClick={() => b.join_url && window.open(b.join_url, '_blank')}
                      disabled={!b.join_url || b.status === 'ended'}
                      className="text-white text-[12px] lg:text-[14px] font-semibold px-4 py-1.5 rounded-[12px] disabled:opacity-40"
                      style={{ backgroundColor: color }}
                    >
                      {b.status === 'ended' ? 'Kapandı' : 'Katıl'}
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default StudentSmartBoard;
